export default "__VITE_ASSET__BdaxSecY__"